import { render, staticRenderFns } from "./OptDetail.vue?vue&type=template&id=14ab2a7e&scoped=true"
import script from "./OptDetail.vue?vue&type=script&lang=js"
export * from "./OptDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ab2a7e",
  null
  
)

export default component.exports